module.exports = __webpack_public_path__ + "static/img/tit6.abe87047.png";